export default {
  BaseUrl: process.env.VUE_APP_BACKEND_HOST,
  StorageType: 'local',
  StorageNamespace: 'mpayn__',
  StorageName: 'ls',
  statusCases: {
    error: [
      'CHARGE_ERROR',
      'PAYMENT_FAILED',
      'PRE_CHARGE_EXCEPTION',
      'REVERSE_INPROGRESS',
      'REVERSED',
      'ERROR',
      'AUTO_REVERSE',
      'EXPIRED',
      'CANCELED',
    ],
    pending: [
      'CREATED',
      'PENDING',
      'CHARGE_INPROGRESS',
      'CHARGE_FINISHED',
      'PAYMENT_CREATED',
      'PAYMENT_INPROGRESS',
      'IN_PROGRESS',
    ],
  },
};
